import { render, staticRenderFns } from "./EditUserFormComponent.vue?vue&type=template&id=b0f25d88&"
import script from "./EditUserFormComponent.vue?vue&type=script&lang=js&"
export * from "./EditUserFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./EditUserFormComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports